import { useEffect } from 'react';

const useDynamicScriptEmbed = (ref, html) => {
  useEffect(() => {
    const currentElement = ref.current;
    if (!currentElement) return;

    currentElement.innerHTML = html;

    const scripts = currentElement.querySelectorAll('script');
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [ref, html]);
}

export default useDynamicScriptEmbed;
